'use client';

import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/core/presentation/components/ui/Tabs';
import { DashboardOverview } from './dashboard-section/DashboardOverview';
import { DashboardFinanceiro } from './dashboard-section/DashboardFinanceiro';
import { DashboardUsuarios } from './dashboard-section/DashboardUsuarios';
import { DashboardServicos } from './dashboard-section/DashboardServicos';
import { DashboardLembretes } from './dashboard-section/DashboardLembretes';
import { DashboardFunil } from './dashboard-section/DashboardFunil';
import { SectionHeader } from '../components/SectionHeader';
import { Lock } from 'lucide-react';

const tabs = [
  { id: 'overview', label: 'Visão Geral' },
  { id: 'financeiro', label: 'Financeiro' },
  { id: 'usuarios', label: 'Usuários' },
  { id: 'servicos', label: 'Serviços' },
  { id: 'lembretes', label: 'Lembretes' },
  { id: 'funil', label: 'Funil de Analytics' },
  { id: 'relatorios', label: 'Relatórios' },
];

export default function DashboardPage() {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div>
      <SectionHeader title="Dashboard" subtitle="Visão geral do sistema RetornaAr" />

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="bg-white border border-admin-border h-auto flex-wrap gap-1 p-1 mb-6 rounded-xl inline-flex">
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.id}
              value={tab.id}
              className={[
                'text-xs rounded-lg px-3 py-2 transition-colors',
                activeTab === tab.id
                  ? 'text-white'
                  : 'text-admin-text-secondary hover:bg-admin-bg-block',
              ].join(' ')}
              style={
                activeTab === tab.id
                  ? { background: 'linear-gradient(155deg, #101f6e 0%, #112793 100%)' }
                  : undefined
              }
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="overview">
          <DashboardOverview />
        </TabsContent>
        <TabsContent value="financeiro">
          <DashboardFinanceiro />
        </TabsContent>
        <TabsContent value="usuarios">
          <DashboardUsuarios />
        </TabsContent>
        <TabsContent value="servicos">
          <DashboardServicos />
        </TabsContent>
        <TabsContent value="lembretes">
          <DashboardLembretes />
        </TabsContent>
        <TabsContent value="funil">
          <DashboardFunil />
        </TabsContent>
        <TabsContent value="relatorios">
          <div className="flex flex-col items-center justify-center py-24 text-admin-text-secondary">
            <Lock className="h-12 w-12 mb-4 opacity-30" />
            <h2 className="text-lg font-semibold text-admin-text">Relatórios</h2>
            <p className="text-sm mt-1">Em breve — recurso em desenvolvimento</p>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}

